import type { KeyboardEvent } from 'react';
import type { QuestionChoiceType } from '~/model/QuestionChoiceType';
import { VpIcon } from '@vtmn-play/react/headless';

export const ChoicePictureFallback = ({
  choice,
  handleClick,
  handleKeyDown,
}: {
  choice: QuestionChoiceType;
  handleClick: () => void;
  handleKeyDown: (e: KeyboardEvent<HTMLLabelElement>) => void;
}) => (
  <div className="control-image">
    <label
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      htmlFor={`choice-${choice.id}`}
      aria-disabled="true"
    >
      <span className="control-image__fallback">
        <VpIcon name="image" size={48} />
      </span>
    </label>
  </div>
);
